import { UserGroup } from '@round/api';

export type NavBarItemGroup = {
    title: string;
    items: NavBarLink[];
    public?: boolean;
};

export type NavBarLink = { title: string; groups: UserGroup[]; url: string; public?: boolean };
export type NavBarItem = NavBarItemGroup | NavBarLink;

export const isNavBarItemGroup = (item: NavBarItem): item is NavBarItemGroup =>
    Array.isArray((item as NavBarItemGroup)?.items);

export function getNavBarItems(items: NavBarItem[]): NavBarItem[] {
    return items.reduce<NavBarItem[]>((acc, item) => {
        if (isNavBarItemGroup(item)) {
            if (item.public ?? true) {
                return [
                    ...acc,
                    {
                        ...item,
                        items: item.items.filter((item) => item.public ?? true),
                    },
                ];
            }
        }
        if (item.public ?? true) {
            return [...acc, item];
        }
        return acc;
    }, []);
}
